import { Directive, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';

// TODO: Add Angular decorator.
@Directive()
export abstract class BaseComponent implements OnDestroy {
  constructor() {}

  ngOnDestroy() {
    if (this._destroy$) {
      this._destroy$.next(true);
      this._destroy$.complete();
    }
  }

  private _destroy$: Subject<any>;

  get destroy$() {
    if (!this._destroy$) this._destroy$ = new Subject();
    return this._destroy$;
  }
}
